import type * as React from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Loader } from '@crehana/ui';
import { useRouter } from 'next/router';

import Error404 from '@/views/Error404';

import useSkillXPTagsByTrack from '../../hooks/useSkillXPTagsByTrack';

const withTagsByTrack =
  (Comp: React.ComponentType<React.PropsWithChildren<any | string>>) =>
  // TODO: talk with the code owner to fix this code so we can enable this rule again
  // eslint-disable-next-line react/display-name
  (props: any) => {
    const router = useRouter();
    const { trackOriginalId, slug, skillB2BUserId } = router.query as {
      slug: string;
      trackOriginalId: string;
      skillB2BUserId: string;
    };

    const {
      loading,
      error,
      skillB2BUserId: userId,
      skillB2bTrackName,
    } = useSkillXPTagsByTrack(parseInt(trackOriginalId, 10));

    if (loading) {
      return (
        <div className="flex items-center justify-center w-full min-h-screen bg-base-lighter-8">
          <Loader />
        </div>
      );
    }

    if (
      error ||
      parseInt(skillB2BUserId, 10) !== userId ||
      slug !== skillB2bTrackName
    ) {
      return <Error404 />;
    }

    return <Comp {...props} />;
  };

export default withTagsByTrack;
